import { theme as oldTheme } from '@vimily/bonjoro-ui-components';
import { theme } from '@vimily/bonjoro-ui-components';
import { DEFAULT_FONT_FAMILY } from '@vimily/bonjoro-ui-components-v2';
import { createContext } from 'react';
import { UserSimple } from '~/types/models';
import {
  Testimonial,
  TestimonialBackgroundType,
  TestimonialQuestion,
} from '~/types/models/testimonial';

export const defaultTestimonialStyles = {
  background_type: TestimonialBackgroundType.Color,
  background_color: theme.colors.white,
  primary_color: theme.colors.yellow.DEFAULT,
  secondary_color: theme.colors.white,
  cta_corner_radius: 4,
  text_color: theme.colors.black,
  font_family: DEFAULT_FONT_FAMILY,
  attachments: {
    box_color: oldTheme.colors.blue[100],
  },
  closing_message: {
    box_color: oldTheme.colors.orange[300],
  },
  outro: {
    box_color: oldTheme.colors.orange[300],
  },
};

export default createContext<Testimonial>({
  uuid: '',
  name: '',
  user: {} as UserSimple,
  questions: {} as TestimonialQuestion[],
  landing_page: {
    background: null,
    logo: null,
  },
  text: {
    intro: '',
    outro: '',
    instruction: '',
  },
  metadata: {
    style: defaultTestimonialStyles,
  },
  request_position_title: false,
  requests: {},
  invite_link: '',
  updated_at: '',
});
